import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web--source/slate/Color";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

import { useChatCsatStore } from "../hooks/ChatCsatContextStore";

import { ChatCsatHeader } from "./ChatCsatHeader";

interface IProps {
  children: React.ReactNode;
}

export const ChatCsatWrapper: React.FC<IProps> = ({ children }) => {
  const { isMobile } = useViewport();
  const [{ surveyType }] = useChatCsatStore(["surveyType"]);

  if (surveyType === "chat") {
    return <ChatWrapper>{children}</ChatWrapper>;
  }

  return (
    <Wrapper>
      <ChatCsatHeader />
      <InnerWrapper>
        <Row justify="center" align="center">
          {isMobile ? null : <Spacer height="3x" />}
          <BackgroundWrapper>
            <ContentWrapper>
              <Container>{children}</Container>
            </ContentWrapper>
          </BackgroundWrapper>
          {isMobile ? null : <Spacer height="3x" />}
        </Row>
      </InnerWrapper>
    </Wrapper>
  );
};

const Container = styled(Column)`
  max-width: 480px;
  input {
    opacity: 0;
  }
`;

const ContentWrapper = styled(Column).attrs({ align: "center" })`
  margin: ${getSpacing("4x", 0)};
  padding: ${getSpacing("4x", "5x")};
  background-color: ${Core.surface.inverse};
  min-height: 100%;
  height: 75vh;
  width: 100%;
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("1x")};
  }
`;

const InnerWrapper = styled(Column)`
  ${responsiveMediaQueries.tabletAndAbove} {
    background-color: ${Core.surface.muted + Opacity.O_80};
  }
  flex: auto;
`;

const Wrapper = styled(Column)`
  width: 100%;
  background-color: transparent;
  height: auto;
  min-height: 100vh;
`;

const ChatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  input {
    opacity: 0;
  }
  padding: ${getSpacing(0, "3x", 0, "3x")};
`;

const BackgroundWrapper = styled.div`
  ${responsiveMediaQueries.tabletAndBelow} {
    width: 100%;
  }
  ${responsiveMediaQueries.desktop} {
    width: 85%;
  }
  ${responsiveMediaQueries.xLargeAndAbove} {
    width: 1150px;
  }
  height: 100%;
`;
